import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectAgroLayoutCurrentTab } from 'redux/reducers/agroLayoutReducer';
import {
  setDeleteErrorDialogOpen,
  setDeleteMessage,
  setDeleteSuccessDialogOpen,
} from 'redux/reducers/meteorologyAgroGroupLocationFeedbackReducer';
import { store } from 'redux/store';
import { ResponseError } from 'services/api/base';
import { useDeleteAgroGroupMutation } from 'services/api/Meteorology/Agro';

export default function useDeleteLocationGroup() {
  const [trigger, { data, isLoading, error }] = useDeleteAgroGroupMutation();
  const currentTab = useSelector(selectAgroLayoutCurrentTab);
  const shouldDisplayMessages = (currentTab !== 'register');

  const deleteGroup = useCallback((id: number) => {
    trigger({ id });
  }, [trigger]);

  useEffect(() => {
    if (data && shouldDisplayMessages) {
      const successMessage = data.message || 'Grupo excluído com sucesso.';
      store.dispatch(setDeleteMessage(successMessage));
      store.dispatch(setDeleteSuccessDialogOpen(true));
    }
  }, [data, shouldDisplayMessages]);

  useEffect(() => {
    if (error && shouldDisplayMessages) {
      const errorMessage = (error as ResponseError).description || 'Erro ao excluir o grupo.';
      store.dispatch(setDeleteMessage(errorMessage));
      store.dispatch(setDeleteErrorDialogOpen(true));
    }
  }, [error, shouldDisplayMessages]);

  return {
    deleteGroup,
    isDeletingGroup: isLoading,
  };
}
